// === CONFIGURACIÓN INICIAL ===
const ignoreColorMeta = document.getElementById('swatch-bg-color');
const ignoreColorHex = ignoreColorMeta ? ignoreColorMeta.dataset.color : '#efefef';

function hexToRgb(hex) {
  if (!hex || typeof hex !== 'string') return null;
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16)
  ] : null;
}

function isLightColor(r, g, b) {
  // Calcula la luminosidad usando la fórmula estándar
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.7; // Si es mayor a 0.7, es un color claro
}

function darkenColor(r, g, b, factor = 0.6) {
  // Oscurece el color multiplicando por un factor
  return [
    Math.round(r * factor),
    Math.round(g * factor),
    Math.round(b * factor)
  ];
}

const ignoreRgb = hexToRgb(ignoreColorHex);

// === WORKER embebido como BLOB con color integrado ===
const workerScript = `
  const ignoreRgb = ${JSON.stringify(ignoreRgb)};
  const threshold = 15;

  function isIgnoredColor([r, g, b]) {
    if (!ignoreRgb) return false;
    
    const [pr, pg, pb] = ignoreRgb;
    const distance = Math.sqrt(Math.pow(r - pr, 2) + Math.pow(g - pg, 2) + Math.pow(b - pb, 2));
    return distance < threshold;
  }

  function getPalette(data, width, height) {
    const colors = {};
    const total = width * height;
    const step = 16; // Group colors in bins of 16

    for (let i = 0; i < total * 4; i += 4) {
      const r = Math.round(data[i] / step) * step;
      const g = Math.round(data[i + 1] / step) * step;
      const b = Math.round(data[i + 2] / step) * step;
      const key = \`\${r},\${g},\${b}\`;
      colors[key] = (colors[key] || 0) + 1;
    }

    return Object.entries(colors)
      .map(([k, count]) => ({ color: k.split(',').map(Number), count }))
      .sort((a, b) => b.count - a.count)
      .map(e => e.color);
  }

  self.onmessage = function (e) {
    const { imageData, width, height } = e.data;
    const palette = getPalette(imageData, width, height);
    const color = palette.find(c => !isIgnoredColor(c)) || palette[0] || [128, 128, 128];
    self.postMessage({ color });
  };
`;

const workerBlob = new Blob([workerScript], { type: 'application/javascript' });
const worker = new Worker(URL.createObjectURL(workerBlob));

// === LÓGICA PRINCIPAL ===
const taskQueue = [];
let isProcessing = false;

function processImageWithWorker(imageData, width, height, prod) {
  return new Promise(resolve => {
    const handleMessage = (e) => {
      const { color } = e.data;
      
      const rgb = `rgb(${color.join(',')})`;
      const circle = prod.querySelector('.color-circle');
      if (circle) {
        circle.style.backgroundColor = rgb;
        
        // Si es el producto activo, aplicar estilos especiales
        if (prod.classList.contains('actual_prod-sw')) {
          circle.style.borderColor = rgb;
          
          // Para el outline, oscurecer el color si es muy claro
          let outlineColor = color;
          if (isLightColor(color[0], color[1], color[2])) {
            outlineColor = darkenColor(color[0], color[1], color[2]);
          }
          circle.style.outlineColor = `rgb(${outlineColor.join(',')})`;
        }
      } else {
        console.error('No se encontró el elemento .color-circle en:', prod);
      }
      worker.removeEventListener('message', handleMessage);
      resolve();
    };

    worker.addEventListener('message', handleMessage);
    worker.postMessage({ imageData, width, height });
  });
}

function processProduct(prod) {
  return new Promise(resolve => {
    const imageUrl = prod.getAttribute('data-img');
    const productId = prod.getAttribute('data-prod');
    
    if (!imageUrl) {
      console.error('No hay URL de imagen para:', productId);
      return resolve();
    }

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = imageUrl;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const size = 50;

      canvas.width = size;
      canvas.height = size;
      ctx.drawImage(img, 0, 0, size, size);

      const imageData = ctx.getImageData(0, 0, size, size).data;

      processImageWithWorker(imageData, size, size, prod).then(resolve);
    };

    img.onerror = () => {
      console.error('Error cargando imagen para:', productId, 'URL:', imageUrl);
      resolve();
    };
  });
}

function runQueue() {
  if (isProcessing || taskQueue.length === 0) return;

  isProcessing = true;
  const prod = taskQueue.shift();

  processProduct(prod).finally(() => {
    isProcessing = false;
    runQueue();
  });
}

function enqueueProduct(prod) {
  taskQueue.push(prod);
  runQueue();
}

// === OBSERVER para lazy loading ===
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      enqueueProduct(entry.target);
    }
  });
}, {
  rootMargin: '100px',
  threshold: 0.1
});

function observeLazyProducts(products) {
  products.forEach(prod => observer.observe(prod));
}

// === CONFIGURACIÓN PERSONALIZABLE ===
const INITIAL_LOAD_LIMIT = 100; // Cambia este valor para ajustar el límite de carga inicial
const USE_LAZY_LOADING = false;  // Cambia a false para deshabilitar IntersectionObserver y cargar todos de una

// === INICIALIZACIÓN ===
document.addEventListener('DOMContentLoaded', () => {
  // Seleccionar TODOS los productos .product-color
  const allProducts = Array.from(document.querySelectorAll('.product-color'));

  if (USE_LAZY_LOADING) {
    // Procesar inmediatamente los primeros INITIAL_LOAD_LIMIT
    const initialProducts = allProducts.slice(0, INITIAL_LOAD_LIMIT);
    initialProducts.forEach(product => {
      enqueueProduct(product);
    });
    // El resto se procesan con lazy loading
    const lazyProducts = allProducts.slice(INITIAL_LOAD_LIMIT);
    observeLazyProducts(lazyProducts);
  } else {
    // Procesar todos los productos directamente
    allProducts.forEach(product => {
      enqueueProduct(product);
    });
  }

  const mutationObserver = new MutationObserver(mutations => {
    const lazy = [];
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node instanceof Element) {
          const newProducts = Array.from(node.querySelectorAll('.product-color'));
          if (USE_LAZY_LOADING) {
            newProducts.slice(0, INITIAL_LOAD_LIMIT).forEach(el => {
              enqueueProduct(el);
            });
            newProducts.slice(INITIAL_LOAD_LIMIT).forEach(el => {
              lazy.push(el);
            });
          } else {
            newProducts.forEach(el => {
              enqueueProduct(el);
            });
          }
        }
      });
    });
    if (USE_LAZY_LOADING && lazy.length) {
      observeLazyProducts(lazy);
    }
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });
});
